import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { href: '#services', label: 'Services' },
    { href: '#portfolio', label: 'Our Work' },
    { href: '#reviews', label: 'Reviews' },
    { href: '#pricing', label: 'Pricing' },
    { href: '#faq', label: 'FAQ' },
    { href: '#contact', label: 'Contact' },
  ];

  const services = [
    'Wall & Ceiling Skimming',
    'Plasterboarding',
    'Patch Repairs',
    'Full Room Plastering',
    'Coving & Mouldings',
    'Rendering',
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_ld-plaster-preview/artifacts/okk5trh7_Gemini_Generated_Image_e8ak78e8ak78e8ak.png" 
                alt="Flex Plastering Logo"
                className="h-40 w-auto"
              />
            </div>
            <p className="text-slate-400 mb-6 leading-relaxed">
              Professional plastering and rendering services 
              across Northampton and surrounding areas.
            </p>
            <div className="space-y-3">
              <a 
                href="tel:07766111127" 
                className="flex items-center gap-3 text-slate-300 hover:text-red-400 transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="w-5 h-5" />
                <span>07766 111127</span>
              </a>
              <a 
                href="mailto:info@flexplastering.co.uk" 
                className="flex items-center gap-3 text-slate-300 hover:text-red-400 transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-5 h-5" />
                <span>info@flexplastering.co.uk</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold font-['Manrope'] mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-slate-400 hover:text-red-400 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold font-['Manrope'] mb-6">Our Services</h3>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index} className="text-slate-400">
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold font-['Manrope'] mb-6">Location</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                <div className="text-slate-400">
                  <p>Northampton Based</p>
                  <p className="text-sm mt-1">Approximately 30-mile radius of Northampton</p>
                </div>
              </div>
              <p className="text-slate-500 text-sm pt-4 border-t border-slate-800">
                Covering Northampton, Wellingborough, Kettering & more
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-8 border-t border-slate-800">
          <div className="flex flex-col lg:flex-row items-center justify-center gap-4">
            <p className="text-slate-500 text-sm">
              &copy; {currentYear} Flex Plastering. All rights reserved.
            </p>
          </div>
        </div>
      </div>

      {/* Google Analytics Placeholder */}
      {/* 
        Add your GA4 tracking code here:
        <script async src="https://www.googletagmanager.com/gtag/js?id=GA_MEASUREMENT_ID"></script>
        <script>
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'GA_MEASUREMENT_ID');
        </script>
      */}
    </footer>
  );
};

export default Footer;
